import { Box, BoxProps, IconButton, LoaderNew, ModBox } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import { ButtonNew } from '../AdminButton'
import { useState } from 'react'

interface SearchByEntityIdProps {
  showSearchByEntityId?: any
  onSearchByEntityIdClick?: any
  showSearchByCrossButton?: any
  showSearchByLoader?: any
  searchByEntityIdPlaceholder?: any
}

export const SearchByEntityId = ({
  onSearchByEntityIdClick = () => {},
  showSearchByCrossButton = false,
  showSearchByLoader = false,
  searchByEntityIdPlaceholder = 'Search By Entity Id...',
}: SearchByEntityIdProps) => {
  const [entityId, setEntityId] = useState('')
  console.log('showSearchByCrossButton', showSearchByCrossButton)
  return (
    <Box {...styles.container}>
      <Box f={1}>
        <TextInput
          placeholder={searchByEntityIdPlaceholder}
          showBottomLine={false}
          fontSize={12}
          editable={!showSearchByCrossButton}
          placeholderTextColor={'BLACK_21'}
          color={'BLACK_75'}
          onChangeText={(text) => {
            setEntityId(text)
          }}
          value={entityId}
        />
      </Box>
      <ModBox show={!showSearchByCrossButton}>
        <ButtonNew
          type={'primaryIcon'}
          onPress={() => onSearchByEntityIdClick(entityId)}
          icon="SEARCH"
          height={34}
          borderRadius={4}
          width={50}
          iconPaddingRight={-30}
          isLoading={showSearchByLoader}
        />
      </ModBox>
      <ModBox show={showSearchByCrossButton}>
        {showSearchByLoader ? (
          <LoaderNew color={'PRIMARY'} />
        ) : (
          <IconButton
            id={'CLOSE'}
            color="PRIMARY"
            size={18}
            onPress={() => {
              setEntityId('')
              onSearchByEntityIdClick('')
            }}
          />
        )}
      </ModBox>
    </Box>
  )
}

const styles = {
  container: {
    borderWidth: 1,
    borderColor: 'BORDER_COLOR',
    borderRadius: 4,
    width: 240,
    height: 34,
    pl: 4,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 2,
    flexDirection: 'row',
  } as BoxProps,
}
